import { render } from "./AssignForm.vue?vue&type=template&id=1854b07e&ts=true"
import script from "./AssignForm.vue?vue&type=script&lang=ts"
export * from "./AssignForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__